import { render, staticRenderFns } from "./IconBagDelivery.vue?vue&type=template&id=01c65033&"
import script from "./IconBagDelivery.vue?vue&type=script&lang=ts&"
export * from "./IconBagDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports